import React from 'react';

import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { Box, Stack, Typography } from '@mui/material';

type Props = {
  /** アイコン（省略時は受信トレイ風アイコン） */
  icon?: React.ReactNode;
  /** 見出し */
  title?: string;
  /** 補足説明 */
  description?: string;
  /** 下部に置くアクション（新規作成ボタン等・任意） */
  action?: React.ReactNode;
};

/**
 * リスト/詳細パネルの空状態を統一表示する共通コンポーネント。
 * SaaS 系の空状態（アイコン + 見出し + 説明 + 任意アクション）に揃える。
 */
const ListEmptyState: React.FC<Props> = ({
  icon,
  title = 'データがありません',
  description,
  action,
}) => (
  <Box
    sx={{
      py: 5,
      px: 3,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1,
    }}
  >
    <Box
      sx={{
        width: 44,
        height: 44,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'action.hover',
        color: 'text.disabled',
        mb: 0.5,
      }}
    >
      {icon ?? <InboxOutlinedIcon sx={{ fontSize: 24 }} />}
    </Box>
    <Typography variant="body2" fontWeight={600} color="text.secondary">
      {title}
    </Typography>
    {description && (
      <Typography variant="caption" color="text.disabled" sx={{ maxWidth: 280 }}>
        {description}
      </Typography>
    )}
    {action && <Stack sx={{ mt: 1 }}>{action}</Stack>}
  </Box>
);

export default ListEmptyState;
